<script>
	var Q = require('q');
	var config = require('core/config');
	var utilities = require('../../utilities');
	var page = require('page');
	var drupalPageService = require('services/drupalPageService');
	var pubsub = require('events/pubsub');
	var accountService = require('services/accountService');
	const analyticsUtilities = require('utilities/analyticsUtilities');

	const fireEvent = analyticsUtilities.fireEvent;
	const PRINT = analyticsUtilities.events.PRINT;
	const OUTBOUND_LINK = analyticsUtilities.events.OUTBOUND_LINK;

	var STATE_MAP = {
		Alabama: 'AL',
		Alaska: 'AK',
		Arizona: 'AZ',
		Arkansas: 'AR',
		California: 'CA',
		Colorado: 'CO',
		Connecticut: 'CT',
		Delaware: 'DE',
		'District of Columbia': 'DC',
		Florida: 'FL',
		Georgia: 'GA',
		Hawaii: 'HI',
		Idaho: 'ID',
		Illinois: 'IL',
		Indiana: 'IN',
		Iowa: 'IA',
		Kansas: 'KS',
		Kentucky: 'KY',
		Louisiana: 'LA',
		Maine: 'ME',
		Maryland: 'MD',
		Massachusetts: 'MA',
		Michigan: 'MI',
		Minnesota: 'MN',
		Mississippi: 'MS',
		Missouri: 'MO',
		Montana: 'MT',
		Nebraska: 'NE',
		Nevada: 'NV',
		'New Hampshire': 'NH',
		'New Jersey': 'NJ',
		'New Mexico': 'NM',
		'New York': 'NY',
		'North Carolina': 'NC',
		'North Dakota': 'ND',
		Ohio: 'OH',
		Oklahoma: 'OK',
		Oregon: 'OR',
		Pennsylvania: 'PA',
		'Rhode Island': 'RI',
		'South Carolina': 'SC',
		'South Dakota': 'SD',
		Tennessee: 'TN',
		Texas: 'TX',
		Utah: 'UT',
		Vermont: 'VT',
		Virginia: 'VA',
		Washington: 'WA',
		'West Virginia': 'WV',
		Wisconsin: 'WI',
		Wyoming: 'WY'
	};

	module.exports = {
		props: ['logged-in', 'route-context'],

		modelData: ['userContext'],

		data: function () {
			return {
				pageTitle: null,
				subTitle: null,
				printLink: null,
				accountInfo: null,
				showShareButtons: false,
				pollForOverflow: null,
				pollForNoOverflow: null,
				pollForVisibility: null
			};
		},

		methods: {
			initialize: function () {
				var iframe = this.getIframe(),
					self = this;

				iframe.css('height', '');

				if (this.userContext && !this.userContext.classCode) {
					$('#edgate-form', iframe.contents()).each(function (i, el) {
						var promise;

						if (!self.accountInfo) {
							promise = accountService.teacherGetAccount().then(function (accountData) {
								self.accountInfo = accountData;
							});
						} else {
							promise = Q(self.accountInfo);
						}

						promise.then(function () {
							if (self.accountInfo.state) {
								$(el)
									.find('#state option[value="' + STATE_MAP[self.accountInfo.state] + '"]')
									.attr('selected', true);
							}

							if (self.accountInfo.gradeSelections) {
								for (var j = 0; j < self.accountInfo.gradeSelections.length; j++) {
									if (self.accountInfo.gradeSelections[j].selected) {
										$(el)
											.find('#grade option[value="' + self.accountInfo.gradeSelections[j].text + '"]')
											.attr('selected', true);

										break;
									}
								}
							}
						});
					});
				}

				$('a', iframe.contents()).click(function (event) {
					if (event) {
						var target = $(event.currentTarget),
							href = target.attr('href');

						if (href[0] === '/' && href.indexOf('.pdf') === -1 && href.indexOf('.doc') === -1) {
							event.preventDefault();
							event.stopImmediatePropagation();

							if (href.indexOf('modal/nojs') === -1) {
								page(href.replace('//' + config.host, ''));
							} else if (!self.userContext || self.userContext.classCode) {
								utilities.openModal('#teacher-login-modal');

								pubsub.subscribeOnce('logged-in', function () {
									window.open('//' + config.host + href, '', 'width=900,height=900');
								});
							} else {
								window.open('//' + config.host + href, '', 'width=900,height=900');
							}
						} else if (target.hasClass('opener')) {
							if (!target.hasClass('open')) {
								// Section is expanded and will be collapsed,
								// poll for "display:none" on section to signify
								// that collapse is complete.
								var slide = target.parents('.content-section').find('.slide');

								self.pollForVisibility = setInterval(function () {
									if (slide.css('display') === 'none') {
										clearInterval(self.pollForVisibility);

										self.pollForVisibility = null;

										// Re-adjust iframe height
										let contentWindow = iframe[0].contentWindow;
										if (contentWindow) {
											iframe.css('height', contentWindow.document.body.clientHeight + 10 + 'px');
										}
									}
								}, 100);
							} else {
								// Section is collapsed and will be expanded,
								// no explicit way to determine that expansion is complete.
								// Poll for overflow (meaning the section has expanded far enough to create scrollbars within scrollbars),
								// then incrementally increase the iframe height until overflow disappears.
								// Assumes rate of iframe height increase is < rate of section expansion.
								self.pollForOverflow = setInterval(function () {
									if (
										iframe &&
										iframe.length &&
										iframe[0] &&
										iframe[0].contentDocument &&
										iframe[0].contentDocument.body &&
										iframe[0].contentDocument.body.clientHeight > iframe[0].clientHeight
									) {
										clearInterval(self.pollForOverflow);

										self.pollForOverflow = null;

										self.pollForNoOverflow = setInterval(function () {
											if (iframe[0] && iframe[0].contentDocument && iframe[0].contentDocument.body) {
												if (iframe[0].contentDocument.body.clientHeight <= iframe[0].clientHeight) {
													clearInterval(self.pollForNoOverflow);

													self.pollForNoOverflow = null;
												} else {
													iframe.css('height', iframe[0].contentDocument.body.scrollHeight + 10 + 'px');
												}
											}
										}, 100);
									}
								}, 100);
							}
						}

						if (target.hasClass('amazon')) {
							let tag = 'CLASSIC_AMAZON';
							fireEvent(OUTBOUND_LINK, {
								path: href,
								tag
							});
						}
					}
				});

				$('#views-exposed-form-lessons-page-1 input[type="submit"]', iframe.contents()).click(function (event) {
					if (event) {
						event.preventDefault();
					}

					page('/lessons/grades?' + $(this).parents('form').serialize());
				});

				let contentWindow = iframe[0].contentWindow;
				if (contentWindow) {
					iframe.css('height', iframe[0].contentWindow.document.body.scrollHeight + 10 + 'px');
				}

				var subFrames = $('iframe', iframe.contents());

				if (subFrames.length) {
					// Seems to be a weird artifact of using the 'javascript:window["contents"]' hack
					subFrames
						.attr('src', $('iframe', iframe.contents()).attr('src').replace('about:', 'https:').replace('javascript:', 'https:'))
						.on('load', function () {
							var $subFrame = $(this),
								subIframeSrc = $subFrame.attr('src');

							if (subIframeSrc.indexOf('about:') !== -1) {
								$subFrame.attr('src', subIframeSrc.replace('about:', 'https:'));
							} else if (subIframeSrc.indexOf('javascript:') !== -1) {
								$subFrame.attr('src', subIframeSrc.replace('javascript:', 'https:'));
							}
						});
				}
			},

			getIframe: function () {
				// Manually querying for the iframe, since v-ref isn't working for some reason
				return $('iframe[name="drupal_frame"]', this.$el);
			},

			onPrint: function () {
				window.open(this.printLink, 'newwindow', 'width=900,height=750');
				fireEvent(PRINT, {
					section: 'RW_CLASSIC'
				});
			},

			forceLogin: function () {
				utilities.openModal('#teacher-login-modal');
			},

			destroyIntervals: function () {
				if (this.pollForOverflow !== null) {
					clearInterval(this.pollForOverflow);
				}

				if (this.pollForNoOverflow !== null) {
					clearInterval(this.pollForNoOverflow);
				}

				if (this.pollForVisibility !== null) {
					clearInterval(this.pollForVisibility);
				}
			}
		},

		mounted() {
			var self = this;

			this.$watch(
				'routeContext.path',
				function (value) {
					self.destroyIntervals();

					if (value.indexOf('modal/nojs') === -1) {
						self.showShareButtons = true;
					}

					self.printLink = null;

					drupalPageService(this.routeContext.pathname).then(function (result) {
						var iframe = self.getIframe();
						var newDocument = document.createElement('html');

						newDocument.innerHTML = result;

						var $newDocument = $(newDocument);

						self.pageTitle = $newDocument.find('.page-title').text();
						self.subTitle = $newDocument.find('#block-readworks-core-readworks-page-heds').text();

						if (self.subTitle.trim() === 'Books and Passages') {
							self.subTitle = 'Books';
						}

						var printLink = $newDocument.find('.toolbar-print a').attr('href');

						if (printLink.indexOf('/print') !== 0) {
							self.printLink = printLink;
						}

						if (value === '/user/alignment') {
							$newDocument.find('#sidebar').remove();
						}

						$newDocument.find('body').css('padding-top', '2rem');
						$newDocument.find('#comments-opener').parents('.content-section').remove();
						$newDocument
							.find(
								'.desk-com, .feedback, .page-title, .menu-mlid-17899, .menu-mlid-17899, #header, #footer, #toolbar-wrapper, #block-readworks-core-readworks-page-heds, #modal-wrapper, #grade > option[value="7"], #grade > option[value="8"]'
							)
							.remove();
						$newDocument.find('.ctools-use-modal').removeClass('ctools-use-modal');
						$newDocument.find('#tab-lesson-plan > div.lesson-plan > div:nth-child(1) > div.instruction-content > ol > li:nth-child(6)').remove();
						$newDocument.find('a').each(function (i, el) {
							var $el = $(el),
								href = $el.attr('href');

							if (!href || href[0] !== '/') {
								return;
							}

							if (href.indexOf('user/binder') !== -1) {
								$el.attr('href', '/binder');
							} else if (href.indexOf('user/profile') !== -1) {
								$el.attr('href', '/my-account');
							} else if (href.indexOf('modal/nojs') === -1 && href.indexOf('.pdf') === -1 && href.indexOf('.doc') === -1) {
								$el.attr('href', '//' + config.host + $el.attr('href'));
							} else if (href.indexOf('.pdf') !== -1 || href.indexOf('.doc') !== -1) {
								$el.attr('href', '//' + drupalPageService.HOST + $el.attr('href'));
							}
						});
						$newDocument.find('link').each(function (i, el) {
							var $el = $(el),
								href = $el.attr('href');

							if (href) {
								if (href.indexOf('readworks.org') !== -1) {
									$el.attr('href', '//' + drupalPageService.HOST + href.replace('http://www.readworks.org', ''));
								} else if (href.indexOf('http:') !== -1) {
									$el.attr('href', href.replace('http:', 'https:'));
								}
							}
						});
						$newDocument.find('script, img').each(function (i, el) {
							var $el = $(el),
								html = $el.html(),
								src = $el.attr('src');

							if (html && (html.indexOf('bs(') !== -1 || html.indexOf('BetterStats') !== -1 || html.indexOf('#modal-wrapper') !== -1)) {
								$el.remove();

								return;
							}

							if (src && src.indexOf('readworks.org') !== -1) {
								if (src.indexOf('VU7P4CTgUZdF2SyFko5LLAg9ZK0OSVjXVaAFnTLgVt0') !== -1) {
									$el.remove();
								} else {
									$el.attr('src', '//' + drupalPageService.HOST + src.replace('http://www.readworks.org', ''));
								}
							}
						});
						$newDocument.find('a[href=#tab-standards-alignment]').parent().remove();
						$newDocument.find('#tab-standards-alignment').remove();

						document.title = $newDocument.find('title').text();
						pubsub.publish('title-change', document.title);

						// http://stackoverflow.com/questions/1736886/why-wont-this-javascript-using-document-open-and-document-write-work-in-inter
						let contentWindow = iframe[0].contentWindow;
						if (contentWindow) {
							iframe[0].contentWindow.contents =
								'<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML+RDFa 1.0//EN" "http://www.w3.org/MarkUp/DTD/xhtml-rdfa-1.dtd">' + $newDocument[0].innerHTML;
						}
						iframe[0].src = 'javascript:window["contents"]';
					});
				},
				{
					immediate: true
				}
			);
		},

		beforeDestroy: function () {
			this.destroyIntervals();
		}
	};
</script>
<template>
	<main
		id="content"
		class="main DrupalHarness"
		role="main">
		<div class="main-content">
			<div class="iframe-header wrapper">
				<div style="float: right">
					<span
						v-if="userContext && !userContext.classCode && printLink"
						@click="onPrint">
						<span class="button">Print</span>
					</span>
					<div
						v-if="(!userContext || userContext.classCode) && printLink"
						@click="forceLogin">
						<span class="button">Print</span>
					</div>
				</div>
				<div
					class="font-small sub-title"
					v-html="subTitle"></div>
				<h2 v-html="pageTitle"></h2>
			</div>
			<iframe
				ref="contentFrame"
				src="about:blank"
				v-on:load="initialize"
				name="drupal_frame"></iframe>
		</div>
	</main>
</template>
<style lang="sass">
	@import 'config/colors';

	.DrupalHarness {
		.iframe-header.wrapper {
			max-width: 944px;
		}

		iframe[name="drupal_frame"] {
			width: 100%;
			border: none;
		}

		.sub-title {
			color: $c-slate-dark;
			font-weight: bold;
		}

		.share-container {
			float: right;
		}

		h2 {
			margin-top: 0;
			margin-bottom: 0;
			color: $c-blue;
		}
	}
</style>
